import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export default styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 1rem;
`;
